import { useEffect } from "react";
import { useI18n, LANGS } from "@/i18n";

const SITE_URL = process.env.REACT_APP_SITE_URL;

const meta = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
};

export const useSeo = ({ title, description, image, path = window.location.pathname }) => {
  const { lang } = useI18n();
  useEffect(() => {
    document.title = title;
    meta('meta[name="description"]', { name: "description", content: description });
    meta('meta[property="og:title"]', { property: "og:title", content: title });
    meta('meta[property="og:description"]', { property: "og:description", content: description });
    meta('meta[property="og:type"]', { property: "og:type", content: "website" });
    if (image) meta('meta[property="og:image"]', { property: "og:image", content: image.startsWith("http") ? image : `${SITE_URL}${image}` });
    const canonicalUrl = `${SITE_URL}${path}`;
    meta('meta[property="og:url"]', { property: "og:url", content: canonicalUrl });
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
    document.head.querySelectorAll('link[data-mb300-hreflang]').forEach((item) => item.remove());
    LANGS.forEach((code) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = code;
      link.href = `${canonicalUrl}?lang=${code}`;
      link.dataset.mb300Hreflang = "true";
      document.head.appendChild(link);
    });
    document.documentElement.lang = lang;
  }, [title, description, image, path, lang]);
};